import { useMemo, useSyncExternalStore } from 'react';

import GeoComplySingleton from '~/utils/geocomply';

import { MarketQueryKeys } from '../constants/query';

const subscribe = (listener: VoidFunction) => GeoComplySingleton.subscribeToLocationToken(listener);

const getSnapshot = () => GeoComplySingleton.getLocationTokenData()?.state;

const getServerSnapshot = () => undefined;

export const getMarketAccountQueryKey = (locationState?: string) =>
  MarketQueryKeys.ACCOUNT(locationState);

export const useMarketAccountQueryKey = () => {
  const locationState = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  return useMemo(() => getMarketAccountQueryKey(locationState), [locationState]);
};
